"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TabsButton = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("../Button");
var TabsContext_1 = require("./TabsContext");
var TabsButton = function (_a) {
    var index = _a.index, className = _a.className, rest = __rest(_a, ["index", "className"]);
    var _b = TabsContext_1.useTabsContext(), uid = _b.uid, currentIndex = _b.currentIndex, changeIndex = _b.changeIndex;
    var isSelected = currentIndex === index;
    var onClick = function () {
        changeIndex(index);
    };
    return (react_1["default"].createElement(Button_1.Button, __assign({ id: "tab-" + uid + "-" + index, role: "tab", "aria-controls": "tabpanel-" + uid + "-" + index, "aria-selected": isSelected, onClick: onClick, className: className }, rest)));
};
exports.TabsButton = TabsButton;
//# sourceMappingURL=TabsButton.js.map